import { useEffect } from 'react';

import { isEqual } from 'lodash';

import { SetFieldValueType } from '../../../features/firmware-management/types/set-field-value.type';
import { IdFile } from '../../../features/shared/models/id-file.model';
import { GetStringKeys } from '../../../features/shared/types/get-string-keys.type';

export const useSyncFileGlobalStateValueWithFormik = <TFormik>(
  setFieldValue: SetFieldValueType,
  stateValue: number | number[] | null,
  fieldName: GetStringKeys<TFormik>,
  formikValue?: number | number[],
  assignedValue?: IdFile[]
) => {
  useEffect(() => {
    if (!isEqual(stateValue, formikValue)) {
      setFieldValue(fieldName, assignedValue || stateValue);
    }
  }, [stateValue]);
};
